export const templates = {
  List: 'List',
};
